<template>
    <div v-if="componentData" class="small-wrapper ">
        <div class="LargeFact">
            <div class="index__holder">{{componentData.caption}}</div>
            <p> {{componentData.fact}} </p>
        </div>
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'

export default defineComponent({
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl
        };
    }
})

</script>
